import React, { PropTypes, Component } from 'react'

import './NextServices.scss'
import RecurrenceCard from './components/RecurrenceCard'
import MultipleTimesPerWeekRecurrenceCard from './components/MultipleTimesPerWeekRecurrenceCard'
import Loader from 'components/Loader'

class NextServices extends Component {
  componentDidMount () {
    this.props.fetchNextServices()
  }

  getOneTimers () {
    return this.props.nextServices.oneTimers || []
  }

  getRecurrences () {
    const allRecurrences = this.props.nextServices.recurrences || []

    return allRecurrences.filter(recurrence => !recurrence.weekdays)
  }

  getMultipleTimesPerWeekRecurrences () {
    const allRecurrences = this.props.nextServices.recurrences || []

    return allRecurrences.filter(recurrence => recurrence.weekdays)
  }

  isLoading () {
    return this.props.fetchingNextServices
  }

  isEmpty () {
    const _isEmpty = x => x === undefined || x.length === 0

    return [
      this.getOneTimers(),
      this.getRecurrences(),
      this.getMultipleTimesPerWeekRecurrences()
    ].every(_isEmpty)
  }

  render () {
    if (this.isLoading()) {
      return this.renderLoader()
    }

    if (this.isEmpty()) {
      return this.renderEmptyState()
    }

    return (
      <div className='NextServices'>
        {this.renderOneTimers()}
        {this.renderRecurrences()}
        {this.renderMultipleTimesPerWeekRecurrences()}
      </div>
    )
  }

  renderLoader () {
    return (
      <div className='NextServices NextServices--fetching'>
        <Loader text='Cargando tus servicios' />
      </div>
    )
  }

  renderEmptyState () {
    return (
      <div className='NextServices'>
        <p className='NextServices-noServices'>
          No tienes servicios próximos
        </p>
      </div>
    )
  }

  renderOneTimers () {
    const { userId } = this.props
    const oneTimers = this.getOneTimers()

    return oneTimers.map((oneTimer) =>
      <RecurrenceCard
        key={oneTimer.id}
        services={[oneTimer]}
        userId={userId}
      />
    )
  }

  renderRecurrences () {
    const { userId } = this.props
    const recurrences = this.getRecurrences()

    return recurrences.map((recurrence) =>
      <RecurrenceCard
        key={recurrence.id}
        recurrence={recurrence}
        services={recurrence.services}
        userId={userId}
      />
    )
  }

  renderMultipleTimesPerWeekRecurrences () {
    const { userId } = this.props
    const multipleTimesPerWeekRecurrences = this.getMultipleTimesPerWeekRecurrences()

    return multipleTimesPerWeekRecurrences.map((multipleTimesPerWeekRecurrence, index) =>
      <MultipleTimesPerWeekRecurrenceCard
        key={index}
        recurrence={multipleTimesPerWeekRecurrence}
        services={multipleTimesPerWeekRecurrence.services}
        userId={userId}
      />
    )
  }
}

NextServices.displayName = 'NextServices'
NextServices.propTypes = {
  nextServices: PropTypes.object.isRequired,
  fetchNextServices: PropTypes.func.isRequired,
  fetchingNextServices: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired
}
NextServices.defaultProps = {}

export default NextServices



// WEBPACK FOOTER //
// ./src/screens/App/screens/UserProfile/screens/UserServices/screens/NextServices/NextServices.js